import { useTranslation } from 'react-i18next';

type SttLabelWeekdaysProps = {
    weekdays?: number[];
};

// Active days mirror the pressed toggle of the weekday picker (`ink` fill with
// `page` text); inactive ones are bare letters in the muted tone. Ink against
// `--muted-foreground` alone was two dark tones that read almost the same, so
// fill and shape now carry the state, not only hue.
const DAY_BASE =
    'inline-flex h-[1.5em] w-[1.5em] items-center justify-center rounded';
const DAY_ACTIVE = 'bg-foreground font-bold text-background';
const DAY_INACTIVE = 'font-normal text-muted-foreground';

/**
 *    Label weekday list
 *    ==================
 *
 * Renders all weekdays as localized letters, highlighting those passed in the weekdays prop.
 * For ex. passing [1, 3, 4] will yield (in spanish) L M X J V S D, with L, X and J filled and the rest muted.
 *
 * Props
 *         * integer[] weekdays
 */
export function SttLabelWeekdays({ weekdays = [] }: SttLabelWeekdaysProps) {
    const { t } = useTranslation();

    if (weekdays.length === 7) {
        return <div>{t('Everyday')}</div>;
    }

    return (
        <div className="inline-flex gap-0.5">
            {[1, 2, 3, 4, 5, 6, 0].map((wd) => (
                <span
                    key={wd}
                    title={t(`day.${wd}.name`)}
                    className={`${DAY_BASE} ${weekdays.includes(wd) ? DAY_ACTIVE : DAY_INACTIVE}`}
                >
                    {t(`weekday.${wd}.letter`)}
                </span>
            ))}
        </div>
    );
}
